module.exports = __webpack_public_path__ + "img/Coinbase2.0bc3b580.png";